import { Button as UIButton } from '@faststore/ui'
import type { ButtonProps } from '@faststore/ui'

type Props = ButtonProps

function ButtonBuy({ children, ...props }: Props) {
  return (
    <UIButton
      data-fs-button
      data-store-buy-button
      data-fs-button-variant="buy"
      {...props}
    >
      {children}
    </UIButton>
  )
}

export default ButtonBuy
